module.exports = __webpack_public_path__ + "static/media/bg5.74609cce.jpg";